import React, { useState, useEffect, Suspense } from 'react';
import { Tabs, Tab, Paper, withStyles, IconButton, Tooltip, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Refresh } from '@material-ui/icons';

import { parseURL, BackButton, hasPermission, formatDate } from '../../sc-utilities';
import { getMediaArrays } from '../../sc-media/utilities';
import config from '../../../config/config';

import { snackActions } from '../../sc-utilities/SnackBar';
import * as storageProductActions from './store/storageProductActions';
import { downloadFile, updateURL } from '../../sc-utilities';
import * as storageActions from '../../sc-productComponents/Storage/store/storageActions';
import * as pcProductActions from '../PCProduct/store/pcProductActions';
import ProductDontLoading from '../ProductDontLoading';
//import Presets from '../../sc-settings/Presets';
import StatisticModal from "../../sc-dashboard/Statistic/StatisticModal";
import {handleChangeCustomer} from "../../sc-dashboard/Statistic";
import * as action from "../../np-dashboard/CustomerBar/store/actions";
import {useChangeActiveCustomerModalHook} from "../hooks/useChangeActiveCustomerModalHook";

const ProductDetails = React.lazy(async () => await import('./StorageProductEditDetails'));
const MediaGallery = React.lazy(async () => await import('../../sc-media/MediaGallery'));
const Report = React.lazy(async () => await import('../../sc-productComponents/Report'));
const StorageList = React.lazy(async () => await import('../../sc-productComponents/Storage'));
const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',

        margin: theme.spacing(),

        [theme.breakpoints.down('sm')]: {
            width: `96.5%`
        }
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};
const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {(value === index || value < 4) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const StorageProductDetails = props => {
    const { classes, theme, onFetchStorageProduct, activeCustomer, onGenerateReport, productEditable, permissions, translations, onCleanStorage, storage, onCleanStorageState, onChangeActiveCustomer } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());
    const [editable, setEditable] = useState({ editable: false, loading: false });
    const [signatures, setSignatures] = useState([]);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [redirectOptions, setRedirectOptions] = useChangeActiveCustomerModalHook(searchParams, activeCustomer);

    useEffect(() => {
        const fetchData = async () => {
            let isEditable = await productEditable({ ProductID: searchParams.productID, ActiveCustomerID: activeCustomer });
            setEditable({ editable: isEditable.productEditable, loading: true });
        }

        fetchData();
        return () => { };
    }, [activeCustomer, productEditable, searchParams.productID]);

    useEffect(() => {
        return () => {

            onCleanStorageState();

            onCleanStorage();
        };
    }, [onCleanStorageState, onCleanStorage]);

    useEffect(() => {

        if (storage && storage.loaded && storage.loaded.Media && storage.loaded.Media.length > 0) {
            const media = getMediaArrays(storage.loaded.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }

        if (storage && storage.loaded && storage.loaded.Signatures && storage.loaded.Signatures.length > 0) {
            let tempSignatures = [];
            const signaturePath = `${config.backend_domain}:${config.backend_port}/static-signature/`;

            storage.loaded.Signatures.forEach((signature) => {
                if (!signature.Deleted) {
                    tempSignatures.push({
                        id: signature.SignatureID,
                        path: signaturePath + signature.ImageLocation,
                        type: 'signature',
                        createdAt: signature.CreatedAt ? formatDate(signature.CreatedAt) : ''
                    });
                }
            });
            setSignatures(tempSignatures);
        }
    }, [storage]);

    const unlockEdit = () => {
        setEditable({ editable: true, loading: true });
        snackActions.snackBar(`${translations['cant_edit_data_text'] || 'Now you can edit data, but it will be overwritten with latest request from QT'}.`, 'warning');
    }
    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };
    const onGenerate = async (data) => {
        await onGenerateReport({ ...data, ComponentID: searchParams.componentID }, translations)
    };

    const getStorageLogData = async () => {
        let data = await props.onStorageDownload(searchParams.productID, { ActiveCustomerID: activeCustomer });
        if (data?.status !== 200) {
            return snackActions.snackBarComponent(data?.message ?? `${translations['not_find_session'] || 'Could not find session data'}!`, 'error');
        }
        if (data) {
            return downloadFile(data.blob, data.fileName);
        }
    };
    let disabled = (typeof storage?.loaded === 'boolean' && !storage?.loaded);

    // const fetchStorageProduct = () => {
    //     onFetchStorageProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
    // }

    return (
        <div>
            {!redirectOptions.open && <>
            <Paper className={classes.root}>
                {disabled ? null : BackButton(translations)}
                {tabValue < 4 && tabValue !== 1 ? <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} disabled={disabled} component="div" onClick={() => setRefresh(true)}>
                        <Refresh />
                    </IconButton>
                </Tooltip> : null}
                {
                    searchParams.type === 'StorageProduct' ?
                        <Tabs
                            value={tabValue}
                            onChange={handleChange}
                            indicatorColor="primary"
                            style={{ padding: 0 }}
                            textColor="primary"
                            variant="fullWidth"
                            scrollButtons="on"
                        >
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["details"] || "Details"} value={0} /> : null}
                            {hasPermission(permissions, 'erasure_report_list') ? <Tab disabled={disabled} label={translations["reports"] || "Reports"} value={1} /> : null}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["media"] || "Media"} value={2} /> : null}
                            {/* {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["presets"] || "Presets"} value={3} /> : null} */}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["storages"] || "Storages"} value={4} /> : null}
                        </Tabs>
                        : null
                }
            </Paper>
            {
                searchParams.type === 'StorageProduct' ?
                    <>
                        { hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={0} value={tabValue}>  <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}>{!disabled && (tabValue < 4 && tabValue !== 1) ? <ProductDetails onFetchStorageProduct={onFetchStorageProduct} deletedMedia={deletedMedia} setDeletedMedia={setDeletedMedia} translations={translations} tabValue={tabValue} onUnpairBulkExternalStorage={props.onUnpairBulkExternalStorage} onUnpairExternalStorage={props.onUnpairExternalStorage} permissions={permissions} editable={editable.editable} unlockEdit={unlockEdit} productEditable={props.productEditable} moveToAnotherPalette={props.moveStorageToAnotherPalette} fetchOrders={props.fetchStorageOrders} onLoadedCleanup={props.storageProductEditInit} onDeleteProduct={props.onDeleteStorageProduct} getLogData={getStorageLogData} onEditProduct={props.onEditStorageProduct} fetchTypicalProblems={props.onFetchStorageTypicalProblems} fetchGrades={props.onFetchStorageGrades} fetchGradingCategories={props.onFetchStorageGradingCategories} productID={searchParams.productID} type={searchParams.type} product={props.storage} onFetchProduct={props.onFetchStorageProduct} setRefresh={setRefresh} refresh={refresh} fetchCollies={props.fetchCollies} /> : <ProductDontLoading />}</Suspense></TabContainer></TabPanel> : null}
                        {hasPermission(permissions, 'erasure_report_list') && editable.loading ? <TabPanel index={1} value={tabValue}>  <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}>{!disabled && tabValue === 1 ? <Report onGenerate={onGenerate} productID={searchParams.productID} /> : <ProductDontLoading />}</Suspense></TabContainer></TabPanel> : null}
                        {hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={2} value={tabValue}>  <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}>{!disabled && (tabValue < 4 && tabValue !== 1) ? <MediaGallery productID={searchParams.productID} refresh={refresh} onRefresh={() => setDeletedMedia(true)} entity={translations['product'] || 'Product'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} signatures={signatures} permissions={permissions} /> : <ProductDontLoading />}</Suspense></TabContainer></TabPanel> : null}
                        {/* {hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={3} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 3 ? 
                            <Presets loadPresets={fetchStorageProduct} updatePresets={onUpdatePresets} loadedPreset={storage.loaded} idParams={{ProductID: searchParams?.productID}}/> : 
                            <ProductDontLoading />} </TabContainer></TabPanel> : <></>} */}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={4} value={tabValue}>  <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}>{!disabled && tabValue === 4 ? <StorageList translations={translations} Type='storage' tabValue={tabValue} editable={editable.editable} productID={searchParams.productID} /> : <ProductDontLoading />}</Suspense></TabContainer></TabPanel> : null}
                    </> : null
            }
            </>}
            {redirectOptions.open ?
                <StatisticModal open={redirectOptions.open}
                                product={redirectOptions.product}
                                handleChangeCustomer={() => handleChangeCustomer(onChangeActiveCustomer, redirectOptions)}
                                handleCloseSafe={() => setRedirectOptions({
                                    ...redirectOptions,
                                    open: !redirectOptions.open
                                })}
                                translations={translations} activeCustomer={activeCustomer} />
                : null}
        </div>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        storage: state.product.storageProducts,
        permissions: state?.core?.login?.permissions || []
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onCleanStorage: () => dispatch(storageActions.cleanState()),
        onUnpairExternalStorage: externalID => dispatch(storageProductActions.unpairExternal(externalID)),
        onUnpairBulkExternalStorage: externalIDs => dispatch(storageProductActions.unpairBulkExternalStorage(externalIDs)),
        onStorageDownload: (productID, customerID) => dispatch(storageProductActions.downloadRawData(productID, customerID)),
        moveStorageToAnotherPalette: data => dispatch(storageProductActions.moveToAnotherPalette(data)),
        fetchStorageOrders: (id) => dispatch(storageProductActions.fetchOrders(id)),
        storageProductEditInit: (id) => dispatch(storageProductActions.loadStorageProductInit(id)),
        onDeleteStorageProduct: (product) => dispatch(storageProductActions.deleteStorageProduct(product)),
        onEditStorageProduct: product => dispatch(storageProductActions.editStorageProduct(product)),
        onFetchStorageTypicalProblems: (id) => dispatch(storageProductActions.fetchTypicalProblems(id)),
        onFetchStorageGrades: product => dispatch(storageProductActions.fetchGrades(product)),
        onFetchStorageGradingCategories: product => dispatch(storageProductActions.fetchGradingCategories(product)),
        onFetchStorageProduct: product => dispatch(storageProductActions.loadStorageProduct(product)),
        onCleanStorageState: (id) => dispatch(storageProductActions.cleanState(id)),
        productEditable: data => dispatch(pcProductActions.productEditable(data)),
        onGenerateReport: (component, translations) => dispatch(storageProductActions.generateReport(component, translations)),
        fetchCollies: (id) => dispatch(pcProductActions.fetchCollies(id)),
        onChangeActiveCustomer: (customerID, path) => dispatch(action.changeActiveCustomer(customerID, path)),

        onUpdatePresets: data => dispatch(pcProductActions.updatePresets(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(StorageProductDetails));